import {
  Component,
  OnInit
} from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { DttableService } from "../services/dttable.service";
import { BaseService } from "../services/base.service";
import { DecimalPipe } from "@angular/common";
import { ToastrService } from "ngx-toastr";
import { BehaviorSubject, Observable, of } from "rxjs";

@Component({
  selector: 'app-drawer',
  templateUrl: './drawer.component.html',
  styles: [
  ]
})
export class DrawerComponent implements OnInit {
  isOpen = false;

  listForm: FormGroup;
  dataSource = [];

  pageIndex = 1;
  pageSize = 15;
  total = 0;
  // dataSource$: Observable<any>;
  // total$: Observable<any>;

  get dataSource$() { return this._dataSoruces$.asObservable(); }
  get total$() { return this._total$.asObservable(); }

  _dataSoruces$ = new BehaviorSubject<any[]>([]);
  _total$ = new BehaviorSubject<number>(0);

  constructor(private fb: FormBuilder, private toaster: ToastrService,
    private baseService: BaseService) {
    this.createForm();
  }



  ngOnInit(): void {

  }

  createForm() {
    this.listForm = this.fb.group({
      Code: [''],
      FirstName: [''],
      LastName: [''],
      ReferenceCode: [''],
      MobileNumber: ['']
    });
  }



  getList() {
    const ele = this.listForm.getRawValue();
    if (ele.Code != '' || ele.FirstName != '' || ele.LastName != '' || ele.ReferenceCode != '' || ele.MobileNumber != '') {
      ele.PageIndex = this.pageIndex;
      this.baseService.callSecureAPI('POST', '/CommonDll/BindEmployeeGeneralDetails', ele)
        .subscribe((res) => {
          const res_item = this.baseService.getReposnse(res);
          if (res_item) {
            this.dataSource = res_item.Data;
            this.total = res_item.Total;
            this._dataSoruces$.next(this.dataSource);
            this._total$.next(this.total);
          }
        });
    } else {
      this.toaster.error('At least one search criteria is mandatory');
    }

  }

  reset() {
    this.createForm();
    this.dataSource = [];
    this.total = 0;
    this._dataSoruces$.next(this.dataSource);
    this._total$.next(this.total);
  }




}
